import { render } from "./EmailForm.vue?vue&type=template&id=62f0d643&scoped=true"
import script from "./EmailForm.vue?vue&type=script&lang=js"
export * from "./EmailForm.vue?vue&type=script&lang=js"

import "./EmailForm.vue?vue&type=style&index=0&id=62f0d643&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62f0d643"

export default script